import { render, staticRenderFns } from "./GridSertec.vue?vue&type=template&id=9d2c65f6&"
import script from "./GridSertec.vue?vue&type=script&lang=ts&"
export * from "./GridSertec.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports